import styled from "styled-components"
import { colors } from "../../helpers/colors"
import { ContentWrapper as GlobalContentWrapper } from "../../ui/content-wrapper/content-wrapper-elements"
import {
  SectionWrapperStyles,
  ContentWrapperStyles,
  InfoBoxWrapperStyles,
  DescriptionStyles,
  ButtonsStyles,
} from "./info-box-styles"

interface ISectionWrapper {
  bgImg?: string
}

export const SectionWrapper = styled.section<ISectionWrapper>`
  background-image: url(${props => props.bgImg});
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 50px;
  ${SectionWrapperStyles}
`

export const ContentWrapper = styled(GlobalContentWrapper)`
  ${ContentWrapperStyles}
`

export const InfoBoxWrapper = styled.div`
  max-width: 544px;
  padding: 35px;
  border: 1px solid ${colors.gray};
  ${InfoBoxWrapperStyles};
`

export const Description = styled.p`
  ${DescriptionStyles};
`

export const Buttons = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 40px;
  & > a:not(:first-child) {
    margin-left: 30px;
  }
  ${ButtonsStyles};
`
